import { render } from "./UpdatePasswordVerification.vue?vue&type=template&id=fe877644&scoped=true"
import script from "./UpdatePasswordVerification.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordVerification.vue?vue&type=script&lang=js"

import "./UpdatePasswordVerification.vue?vue&type=style&index=0&id=fe877644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe877644"]])

export default __exports__